import React, { useEffect, useState, useCallback } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import Button from 'react-bootstrap/Button';
import {
  MDBContainer,
  MDBTabs,
  MDBTabsItem,
  MDBTabsLink,
  MDBTabsContent,
  MDBTabsPane,
  MDBBtn,
  MDBIcon,
  MDBInput,
  MDBCheckbox
}
  from 'mdb-react-ui-kit';
import styled from 'styled-components';

import axios from 'axios';

import { useNavigate } from 'react-router-dom'; // Import useHistory for navigation

import { selectAuth } from '../../slices/authSlice';
import { useSelector, useDispatch } from 'react-redux'
import Accordion from 'react-bootstrap/Accordion';
import ImageViewer from 'react-simple-image-viewer';
import ReactPlayer from 'react-player'
import ImageTileComponent from '../ImageTileComponent';

const GreenTab = styled(MDBTabsLink)`
    background-color: green; /* Change to your desired shade of green */
    color: white; /* Change text color if needed */
`;

function Uploads_Today() {

  const [justifyActive, setJustifyActive] = useState('tab1');;
  const { isAuthenticated, userInformation } = useSelector(selectAuth);
  const dispatch = useDispatch()
  const navigate = useNavigate();

  const [data, setData] = useState([]);
  let [loadingData, setLoadingData] = React.useState(true);

  const [currentImage, setCurrentImage] = useState(0);
  const [isViewerOpen, setIsViewerOpen] = useState(false);
  const [images, setImages] = useState([]);

  const openImageViewer = useCallback((filename, index) => {
    setImages([filename])
    setCurrentImage(0);
    setIsViewerOpen(true);
  }, []);

  const closeImageViewer = () => {
    //console.log(images[0])
    setCurrentImage(0);
    setIsViewerOpen(false);
  };

  const handleJustifyClick = (value) => {
    if (value === justifyActive) {
      return;
    }

    setJustifyActive(value);
  };

  useEffect(() => {
    const fetch = async () => {
      try {
        console.log("aaa")
        const response = await axios.get('/api/defisuploads/today/');
        if (response.status == 200) {
          console.log(response.data)
          setData(response.data)
        }
      } catch (error) {
        console.error('Error:', error);
        // Handle error appropriately, e.g., show an error message or dispatch a failure action
      } finally {
        setLoadingData(false)
      }

    };
    fetch();
  }, []);




  return (
    <Container>
      <h1 className="my-3">Today's Uploads</h1>

      {loadingData ?
        (<></>)
        :
        (<Accordion defaultActiveKey="0">
          {
            data.map((district, index) => {
              return (
                <Accordion.Item eventKey={index}>
                  <Accordion.Header>{district.name}</Accordion.Header>
                  <Accordion.Body className="p-2">
                    <Accordion defaultActiveKey="0">
                      {

                        district.Troupes.map((troupe, indexx) => {
                          return (
                            <Container>
                              <Row className="mt-3"><h3>
                                {troupe.name ? `${troupe.groupe} - ${troupe.name}` : troupe.groupe}
                              </h3></Row>
                              <Row>
                                <Accordion defaultActiveKey="0">
                                  {
                                    troupe.Defis.length !== 0 ? (
                                      troupe.Defis.map((defi, indexx) => {
                                        return (
                                          <Accordion.Item eventKey={indexx} key={indexx}>
                                            <Accordion.Header>
                                            {`${defi.title} - ${defi.subtitle}`}
                                            </Accordion.Header>
                                            {/* <Accordion.Body className="p-2">
                                              <Accordion defaultActiveKey="0"> */}
                                                {
                                                  defi.Patrouilles.map((patrouille, indexxx) => {
                                                    return (
                                                      // <Accordion.Item eventKey={indexxx} key={indexxx}>
                                                        // <Accordion.Header>
                                                        //   {patrouille.totem}
                                                        // </Accordion.Header>
                                                        <Accordion.Body>
                                                          {patrouille.defisuploads && patrouille.defisuploads.length > 0 ? (
                                                            <>
                                                              <p>{patrouille.totem}</p>
                                                              <ImageTileComponent data={patrouille.defisuploads}/>
                                                            
                                                            </>
                                                          ) : (
                                                            "No uploads"
                                                          )}

                                                        </Accordion.Body>
                                                      // </Accordion.Item>
                                                    );
                                                  })
                                                }
                                              {/* </Accordion>
                                            </Accordion.Body> */}
                                          </Accordion.Item>
                                        );
                                      })
                                    ) : (
                                      <p>No Troupes Found</p>
                                    )
                                  }


                                </Accordion>
                              </Row>
                            </Container>
                          )
                        })
                      }

                    </Accordion>
                  </Accordion.Body>
                </Accordion.Item>
              )
            })
          }

        </Accordion>
        )
      }
    </Container>
  );
}

const styles = {
  gallery: {
    display: "flex", // Use Flexbox
    flexWrap: "wrap", // Wrap images to the next line if they don't fit
    gap: "10px", // Space between images
  },
  imageContainer: {
    width: "100px", // Fixed width for each image container
    height: "100px",
    overflow: "hidden", // Hide overflow
    borderRadius: "8px", // Optional: Rounded corners
    border: "1px solid #ddd", // Optional: Add a border
  },
  image: {
    width: "100%", // Fill the container
    height: "100%",
    objectFit: "cover", // Ensure the image covers the container
  },
};

export default Uploads_Today;